import { memo, useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import NavGroup from './NavGroup';
import getMenuItems from '../../../menu-items'; // <-- function, not static object

function MenuList() {
  const role = localStorage.getItem('userRole'); // get role from localStorage
  const drawerOpen = true; // or pass it as a prop if you need
  const [selectedID, setSelectedID] = useState('');
  const [items, setItems] = useState([]);

  // Build menu once role is available
  useEffect(() => {
    if (role) {
      const fetchedMenu = getMenuItems(role); // pass role
      if (fetchedMenu?.items) setItems(fetchedMenu.items);
    }
  }, [role]);

  // Loading fallback
  if (!items.length) {
    return <Box sx={{ p: 2, mt: 3 }}>Loading menu...</Box>;
  }

  const navItems = items.map((item, index) => {
    const delay = drawerOpen ? `${index * 60}ms` : '0ms';
    if (item.type === 'group') {
      return (
        <div key={item.id} style={{ animation: `groupFadeIn 0.3s ease-out ${delay} both` }}>
          <NavGroup item={item} setSelectedID={setSelectedID} selectedID={selectedID} />
        </div>
      );
    }
    return null;
  });

  return (
    <Box
      sx={{
        maxHeight: '100%',
        overflowY: 'auto',
        mt: drawerOpen ? 0.5 : 0,
        '&::-webkit-scrollbar': { width: '5px' },
        '&::-webkit-scrollbar-track': { background: '#F5F7FA' },
        '&::-webkit-scrollbar-thumb': { background: '#BDC3C7', borderRadius: '3px', '&:hover': { background: '#95A5A6' } },
        scrollBehavior: 'smooth',
      }}
    >
      {navItems}
      <style jsx global>{`
        @keyframes groupFadeIn {
          from { opacity: 0; transform: translateY(6px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </Box>
  );
}

export default memo(MenuList);



// // MenuList.jsx
// import { memo, useState } from 'react';
// import List from '@mui/material/List';
// import Box from '@mui/material/Box';
// import NavItem from './NavItem';
// import NavGroup from './NavGroup';
// import menuItems from '../../../menu-items';
// import { useGetMenuMaster } from '../../../api/menu';

// function MenuList() {
//   const { menuMaster } = useGetMenuMaster();
//   const drawerOpen = menuMaster.isDashboardDrawerOpened;
//   const [selectedID, setSelectedID] = useState('');

//   const navItems = menuItems.items.map((item, index) => {
//     const delay = drawerOpen ? `${index * 60}ms` : '0ms';
//     switch (item.type) {
//       case 'group':
//         return (
//           <div key={item.id} style={{ animation: `groupFadeIn 0.3s ease-out ${delay} both` }}>
//             <NavGroup
//               item={item}
//               setSelectedID={setSelectedID}
//               selectedID={selectedID}
//             />
//           </div>
//         );
//       default:
//         return null;
//     }
//   });

//   return (
//     <Box
//       sx={{
//         maxHeight: '100%',
//         overflowY: 'auto',
//         mt: drawerOpen ? 0.5 : 0,
//         '&::-webkit-scrollbar': { width: '5px' },
//         '&::-webkit-scrollbar-track': { background: '#F5F7FA' },
//         '&::-webkit-scrollbar-thumb': {
//           background: '#BDC3C7',
//           borderRadius: '3px',
//           '&:hover': { background: '#95A5A6' }
//         },
//         scrollBehavior: 'smooth'
//       }}
//     >
//       {navItems}
//       <style jsx global>{`
//         @keyframes groupFadeIn {
//           from { opacity: 0; transform: translateY(6px); }
//           to { opacity: 1; transform: translateY(0); }
//         }
//       `}</style>
//     </Box>
//   );
// }

// export default memo(MenuList);